import { notifications as API } from '../../api'
import Notification from '../models/Notification'

import { store } from 'w3box-vue-api'
const { state, getters, actions, mutations } = store

export default {
  namespaced: false,
  state: state(),
  getters: {
    ...getters(),
    items: state => Notification.query().orderBy('created_at', 'desc').get()
  },
  actions: {
    ...actions(API),
    status({ commit, dispatch }, status) {
      Notification.insertOrUpdate({ data: status.items })
      if(!window.Echo) return
      window.Echo.private(status.channel).notification(notification => {
        // if(notification.type == 'App\Notification\Notification')
        // console.log(notification)
        // delete notification.type
        // delete notification.socket
        Notification.insert({ data: notification }).then(data => {
          const notification = data.notifications[0]
          // commit('NEW', notification)
          dispatch('notify', notification, { root: true })
        })
      })
    },
    markAsRead({ commit, dispatch }, notification) {
      API.markAsRead(notification.id)
        .then(response => commit('MARK_AS_READ', notification.id))
        .catch(failed => dispatch('failed', failed, { root: true }))
    },
    markAllRead({ commit, dispatch }) {
      API.markAllRead()
        .then(response => commit('MARK_ALL_READ'))
        .catch(failed => dispatch('failed', failed, { root: true }))
    },
  },
  mutations: {
    ...mutations(),
    MARK_AS_READ: (state, id) => Notification.delete(id),
    MARK_ALL_READ: state => Notification.deleteAll(),
    // NEW: (state, notification) => state.items.unshift(notification),
  }
}